module.exports = __webpack_public_path__ + "img/combat-desc.f9f574f1.png";